import React, { Component } from 'react';
import _ from 'lodash';
import './Slot.css';

export class Slot extends Component {
  render() {
    const {
      scroll,
      value
    } = this.props;
    return <div className="slot">
      <div className={`slotScroller ${value} ${scroll ? 'scroll' : 'in'}`} />
    </div>;
  }
}


// WEBPACK FOOTER //
// ./src/components/Controller/Slot/Slot.js